// ASCII art for the grim_repo homepage. Trogdor, obviously.
// The title banner was generated with figlet ("Standard" font); the
// little stick-figure dragon-man below it is hand drawn in the same
// spirit as the original Strong Bad Sketchies masterpiece: a triangle
// head, a burninating mouth, and a pile of legs.

export const TROGDOR_TITLE = `
  _____ ____   ___   ____ ____   ___  ____
 |_   _|  _ \\ / _ \\ / ___|  _ \\ / _ \\|  _ \\
   | | | |_) | | | | |  _| | | | | | | |_) |
   | | |  _ <| |_| | |_| | |_| | |_| |  _ <
   |_| |_| \\_\\\\___/ \\____|____/ \\___/|_| \\_\\
`;

export const TROGDOR_DRAGON = `
                    ^       ^   ^
                 ^     ^  FIRE  ^     ^
                    ^   ^     ^    ^
                       \\   |   /
                        \\  |  /
                        .-'"#"'-.
                       /   ^ ^   \\
                      |     ^     |
                       \\_..---.._/
                          |   |
                          |   |
                         /|   |\\
                        / |   | \\
                  .----'  |   |  '----.
                 /    |   |   |   |    \\
                /     |   |   |   |     \\
               *      *   *   *   *      *
`;

export const TROGDOR_TAGLINE = '>>> BURNINATING THE COUNTRYSIDE <<<';
